module.exports = __webpack_public_path__ + "static/img/logonnhfy.f9d1c8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nhfy/logonnhfy.png
// module id = ZJqa
// module chunks = 2